import React from 'react'
import Price, { discountPercent } from './Price'

// extra props (e.g. data-item-id) go to the card button
const ProductCard = ({ name, image, meta, mrp, finalPrice, onClick, ...rest }) => {
    const off = discountPercent(mrp, finalPrice)
    return (
        <button type='button' className='mv-product-card' onClick={onClick} {...rest}>
            <div className='mv-product-media'>
                <img className='mv-product-img' src={image} alt={name || 'Product'} loading='lazy' />
                {off > 0 && <span className='mv-chip mv-chip-discount mv-product-badge'>{off}% OFF</span>}
            </div>
            <div className='mv-product-body'>
                <span className='mv-product-name'>{name}</span>
                {meta && <span className='mv-product-meta'>{meta}</span>}
                <Price finalPrice={finalPrice} mrp={mrp} />
            </div>
        </button>
    )
}

export default ProductCard
